import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import store from './store'

import '@fortawesome/fontawesome-free/css/all.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/scss/main.scss'

import { i18n } from '@/i18n'

import router from '@/router'
import { cookieManager } from '@/service/cookieManager'
import { userRepository } from '@/service/repository/userRepository'
import { reservationRepository } from '@/service/repository/reservationRepository'
import { allergenRepository } from '@/service/repository/allergenRepository'
import { cartSessionRepository } from '@/service/repository/cartSessionRepository'
import { venueRepository } from '@/service/repository/venueRepository'
import { menuRepository } from '@/service/repository/menuRepository'
import { notificationRepository } from '@/service/repository/notificationRepository'
import { speakService } from '@/service/speakService'
import { copilotRepository } from '@/service/repository/copilotRepository'
import { cameraService } from '@/service/cameraService'
import { dateFormatterService } from '@/service/dateFormatterService'
import { listenService } from '@/service/listenService'
import { harvisService } from '@/service/harvisService'
import { productOrderRepository } from '@/service/repository/productOrderRepository'
import { walkingService } from '@/service/walkingService'
import { translationRepository } from '@/service/repository/translationRepository'
import { productOrderService } from '@/service/ProductOrderService'
import { billRepository } from '@/service/repository/billRepository'
import { voucherRepository } from '@/service/repository/voucherRepository'
import { reservationPromotionRepository } from '@/service/repository/reservationPromotionRepository'

if (window.location.pathname.startsWith('/copilot')) {
	import('./registerServiceWorker')
}

const app = createApp(App)
const pinia = createPinia()

app.use(router)
app.use(store) // Vuex store (existing)
app.use(pinia) // Pinia store (new)
app.use(i18n)
// Inyectar servicios globales
app.provide('cookieManager', cookieManager)
app.provide('dateFormatterService', dateFormatterService)
app.provide('speakService', speakService)
app.provide('listenService', listenService)
app.provide('harvisService', harvisService)
app.provide('cameraService', cameraService)
app.provide('notificationRepository', notificationRepository)
app.provide('userRepository', userRepository)
app.provide('copilotRepository', copilotRepository)
app.provide('reservationRepository', reservationRepository)
app.provide('allergenRepository', allergenRepository)
app.provide('cartSessionRepository', cartSessionRepository)
app.provide('venueRepository', venueRepository)
app.provide('translationRepository', translationRepository)
app.provide('billRepository', billRepository)
app.provide('menuRepository', menuRepository)
app.provide('productOrderRepository', productOrderRepository)
app.provide('walkingService', walkingService)
app.provide('productOrderService', productOrderService)
app.provide('voucherRepository', voucherRepository)
app.provide('reservationPromotionRepository', reservationPromotionRepository)

app.mount('#app')
